<div [ngClass]="widgetCssClassName()" class="w-full h-full py-0">
  <div class="search-widget-v3-mobile__free-search">
    <div class="input-wrap grow">
      <mat-form-field appearance="outline">
        <div [formGroup]="freeSearchForm" class="search-wrapper">
          <div class="search-icon-wrapper">
            <app-ui-icon color="var(--grey-3)" name="search" size="md"></app-ui-icon>
          </div>
          <input
            (focus)="onFreeSearchClick()"
            autoComplete="off"
            class="test-search-autocomplete-input"
            formControlName="term"
            matInput
            placeholder="Sök efter vårdtjänst, mottagning eller ort"
            type="search"
          >
        </div>
      </mat-form-field>

    </div>
  </div>

  @if (hideFiltersAndPlacePanel() !== true && isInline() !== true) {
    <div class="search-widget-v3-mobile__filters-buttons">
      <app-ui-button
        (onClick)="onPlaceClick()"
        [color]="(placesFieldValue() !== '' ? 'outline-tertiary-green' : 'outline-tertiary')"
        [disabled]="false"
        [expanded]="'inline'"
        [size]="'sm'"
        class="test-places-filter-button"
      >
        <app-ui-icon name="marker"></app-ui-icon>
        {{ (placesFieldValue() !== '' ? placesFieldValue() : 'Välj plats') }}
      </app-ui-button>
    </div>
  }

</div>



